module.exports = __webpack_public_path__ + "static/media/codechef.42803a2d.png";